import React from 'react';
import checkIcon from '../../../../../../assets/image/check_stock_icon.svg';
import closeIcon from '../../../../../../assets/image/close.svg';
import PageLoader from '../../../../../../component/PageLoader';

const CATEGORY_ORDER = [
	'Core',
	'Inventory',
	'Sales',
	'Purchases',
	'Integrations',
	'Automation',
	'Advanced Analytics',
];

const resolveFeatureDisplay = (item) => {
	if (item.is_unlimited || item.value === 'unlimited') {
		return { label: `Unlimited ${item.name}`, available: true };
	}
	if (item.value === true) return { label: item.name, available: true };
	if (item.value === false) return { label: item.name, available: false };
	if (typeof item.value === 'number')
		return { label: `${item.value} ${item.name}`, available: true };
	if (typeof item.value === 'string')
		return { label: `${item.value} ${item.name}`, available: true };
	return { label: item.name, available: false };
};

const deduplicateByKey = (items) => {
	const map = new Map();
	for (const item of items ?? []) {
		map.set(item.key, item);
	}
	return Array.from(map.values());
};

const sortedCategories = (features) => {
	const entries = Object.entries(features);
	const ordered = [];
	const remaining = [];

	for (const cat of CATEGORY_ORDER) {
		const found = entries.find(([key]) => key === cat);
		if (found) ordered.push(found);
	}

	for (const entry of entries) {
		if (!CATEGORY_ORDER.includes(entry[0])) remaining.push(entry);
	}

	return [...ordered, ...remaining];
};

export default function SubscriptionFeatures({ features, loader }) {
	return (
		<div>
			<div
				className="rounded-3 my-2"
				style={{ border: '1px solid rgba(85, 91, 103, 0.15)' }}
			>
				<div className="fs-3 fw-semibold text-dark py-4 px-5">Features</div>
				<div className="subscription-border" />

				{loader ? (
					<PageLoader />
				) : features ? (
					<div className="row g-4 px-4 pb-4">
						{sortedCategories(features).map(([category, items], index) => {
							const uniqueItems = deduplicateByKey(items);

							return (
								<div
									className="col-md-6 col-lg-4"
									key={index}
								>
									<div className="p-4">
										<h5 className="fs-4 font-medium mb-4">{category}</h5>

										{uniqueItems.length > 0 ? (
											uniqueItems.map((item, i) => {
												const { available } = resolveFeatureDisplay(item);

												return (
													<div
														key={i}
														className="d-flex align-items-start gap-3 mb-3"
														style={{ opacity: available ? 1 : 0.45 }}
													>
														<img
															src={available ? checkIcon : closeIcon}
															alt={available ? 'included' : 'not included'}
															width={18}
															height={18}
															style={{ marginTop: 2, flexShrink: 0 }}
														/>

														<div className="d-flex flex-column">
															<span
																className="fs-5 font-small"
																style={{ color: 'rgba(85, 91, 103, 1)' }}
															>
																{item.name}
															</span>
															{item.input_type !== 'boolean' && item.value !== null && (
																<span
																	className="fs-6 fw-semibold mt-1"
																	style={{
																		color: available
																			? 'rgba(104, 194, 48, 1)'
																			: 'rgba(220, 53, 69, 1)',
																	}}
																>
																	{item.is_unlimited || item.value === 'unlimited'
																		? 'Unlimited'
																		: item.value}
																</span>
															)}
														</div>
													</div>
												);
											})
										) : (
											<div className="text-muted fs-5 font-small">No features</div>
										)}
									</div>
								</div>
							);
						})}
					</div>
				) : (
					<div className="text-muted fs-5 px-5 pb-4">No features available</div>
				)}
			</div>
		</div>
	);
}
